import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"
import DeleteCell from "./cells/DeleteCell";

import ConfirmationModal from "../modal/ConfirmationModal";
import LinkedAccountModal from "../modal/LinkedAccountModal";

import Backend from '../../../utils/Backend'
import Notify from "../../../utils/Notify";

export default class LinkedAccountsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      live: props.live
    }

    this.table = React.createRef()
  }

  _renderNameCell(member){
    let name = `${member?.user?.first_name || ""} ${member?.user?.last_name || ""}`
    let companyName = member?.company?.name || "-"

    return (
      <div className="d-flex align-items-center">
        <div>
          <div className="text-dark-75 font-weight-bold line-height-sm">
            {companyName}
          </div>
          <div className="font-size-sm text-dark-50">{name}</div>
        </div>
      </div>
    )
  }

  _getColumns() {
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: linkedUser => moment(linkedUser.created_at).format('DD MMM YYYY'),
        width: 160
      },
      {
        Header: 'User',
        id: 'from_user',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          const member = rowInfo.original.from_user

          let name = `${member.user?.first_name || ""} ${member.user?.last_name || ""}`
          return (
            <div className="d-flex align-items-center">
              <div>
                <div className="text-dark-75 line-height-sm">
                  {name}
                </div>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Target Company',
        id: 'from_user',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          const member = rowInfo.original.to_user

          return (
            <div className="d-flex align-items-center">
              <div>
                <div className="text-dark-75 line-height-sm">
                  {member?.company?.name}
                </div>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Created By',
        id: 'created_by',
        accessor: linkedUser => `${linkedUser.created_by?.first_name || ""} ${linkedUser.created_by?.last_name || ""}`,
      },
      {
        Header: 'Actions',
        id: 'status',
        sortable: false,
        exportable: false,
        width: 180,
        Cell: rowInfo => {
          let linkedUser = rowInfo.original

          if(linkedUser.deleted_at) return null

          return (
            <span style={{overflow: 'visible', position: 'relative', width: 150}}>
              <DeleteCell
                onDeleteClicked={() => {
                  this.setState({
                    showConfirmationModal: true,
                    linkedUser
                  })
                }}
              />
            </span>
          )
        }
      }
    ]
  }

  _deleteLinkedUser(){
    let {
      linkedUser
    } = this.state

    Backend.deleteLinkedUser(linkedUser)
    .then(() => {
      Notify.success("Account Group Has Been Deleted")
      this.setState({ loading: false, showConfirmationModal: false })
      this.table.current.refresh()
    })
    .catch(error => {
      this.setState({ loading: false })
      Notify.error(error.message)
    })
  }

  _renderToolBar(){
    return (
      <>
        <a className="btn btn-primary font-weight-bolder"
           onClick={() => {
            this.setState({
              showAccountGroupingModal: true,
              linkedUser: null
            })
           }}
        >
          <span className="svg-icon svg-icon-md">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px"
                 height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect fill="#000000" x="4" y="11" width="16" height="2" rx="1"></rect>
                <rect fill="#000000" opacity="0.3"
                      transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) "
                      x="4" y="11" width="16" height="2" rx="1"></rect>
              </g>
            </svg>
          </span>
          Add Linked Account
        </a>
      </>
    )
  }

  _renderAccountGroupingModal(){
    let {
      showAccountGroupingModal,
    } = this.state

    if(!showAccountGroupingModal) return null

    return (
      <LinkedAccountModal
        show={showAccountGroupingModal}
        onHide={() => this.setState({ showAccountGroupingModal: false, linkedUser: null })}
        onAdded={() => {
          this.table.current.refresh()
          this.setState({showAccountGroupingModal: false, linkedUser: null})
        }}
      />
    )
  }

  _renderConfirmationModal(){
    let {
      showConfirmationModal
    } = this.state

    return (
      <ConfirmationModal
        show={showConfirmationModal}
        title={"Are you sure? This action can't be redone."}
        onConfirm={() => {
          this._deleteLinkedUser()
        }}
        onHide={() => {
          this.setState({
            linkedUser: null,
            showConfirmationModal: false
          })
        }}
      />
    )
  }

  render() {
    let {
      live,
    } = this.state
    const columns = this._getColumns()

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.LinkedUsers}`}
          noDataMessage={"No Linked Accounts Found"}
          title={this.props.title}
          columns={columns}
          showExport={false}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          showSearch={true}
          showPaginationBottom={true}
          renderToolbar={() => this._renderToolBar()}
        />
        { this._renderAccountGroupingModal() }
        { this._renderConfirmationModal() }
      </div>
    )
  }
}

LinkedAccountsTable.defaultProps = {
  latestResults: false
}
